import { themeColor } from '@elparking/components'
import styled from 'styled-components'

const ResumeContainer = styled.div`
    border-radius: 3px 3px 20px 3px;
    padding: 1em;
    border: 1px solid ${themeColor('gray20')};
`

export default ResumeContainer
